
import { BACKEND_URL } from '../../utils/config';

const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || "/backend";

export async function checkIsLoggedIn() {
    let response = await fetch(`${BACKEND_URL}/users/current`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
    });

    return response.status == 200;
}

export async function handleFetchResponse(response, navigate) {
    // If 401, redirect to login
    if (response.status === 401) {
        localStorage.clear();
        navigate(`${FRONTEND_URL}/login`);
        return null;
    }
    return response;
}